export default () => {
    (() => {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
    })();

    (() => {
        Date.prototype.getMonthName = function () {
            return [
                "January",
                "Februray",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ][this.getMonth()];
        };
    })();

    (() => {
        Date.prototype.getWeekNumber = function () {
            var onejan = new Date(this.getFullYear(), 0, 1);
            var millisecsInDay = 86400000;
            return Math.ceil(
                ((this - onejan) / millisecsInDay + onejan.getDay() + 1) / 7,
            );
        };
    })();

    (() => {
        Date.prototype.getWeekDayName = function () {
            return [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ][this.getDay()];
        };
    })();

    (() => {
        Date.isSameDay = (rawDate1, rawDate2) => {
            const date1 = new Date(rawDate1);
            const date2 = new Date(rawDate2);

            return !!(
                date1.getDate() === date2.getDate() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getFullYear() === date2.getFullYear()
            );
        };
    })();
};
